function setupModals() {
    const modals = document.querySelectorAll('.has-modal');
    modals.forEach(block => {
        const opener = block.querySelector('.modal-opener');
        const dialog = block.querySelector('.modal-dialog');
        const closer = block.querySelector('.modal-closer');
        opener.addEventListener('click', () => {
            dialog.showModal();
        });
        closer.addEventListener('click', () => {
            dialog.close();
        });
        dialog.addEventListener('click', (e) => {
            if (e.target == dialog) {
                dialog.close();
            }
        });
    });
    // video modals
    const videos = document.querySelectorAll('.has-video-fs');
    videos.forEach(video => {
        const opener = video.querySelector('.dialog-toggle.open');
        const closer = video.querySelector('.dialog-toggle.close');
        opener.addEventListener('click', () => {
            video.setAttribute("data-fullscreen", "true");
            document.addEventListener('keydown', keyDownListener);
        });
        closer.addEventListener('click', () => {
            video.removeAttribute("data-fullscreen");
            document.removeEventListener('keydown', keyDownListener);
        });
        video.addEventListener('click', (event) => {
            if (event.target === video) {
                video.removeAttribute("data-fullscreen");
                document.removeEventListener('keydown', keyDownListener);
            }
        });
        const keyDownListener = (event) => {
            if (event.key === 'Escape') {
                video.removeAttribute("data-fullscreen");
            }
        };
    });
}
export default setupModals;
